import { Configuration, LogLevel } from '@azure/msal-browser';

// =============================================================================
// USER AUTH - Entra External ID (CIAM)
// For household members (customers outside your org)
// =============================================================================
export const userMsalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_USER_CLIENT_ID || '',
    // External ID uses .ciamlogin.com
    authority: import.meta.env.VITE_USER_AUTHORITY || '',
    knownAuthorities: [import.meta.env.VITE_USER_AUTHORITY?.replace('https://', '').split('/')[0] || ''],
    redirectUri: `${window.location.origin}/auth-callback`,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'localStorage',
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
        if (containsPii) return;
        if (level === LogLevel.Error) console.error(message);
      },
      logLevel: LogLevel.Error,
    },
  },
};

export const userLoginRequest = {
  scopes: [import.meta.env.VITE_USER_API_SCOPE || 'openid', 'profile', 'email'],
};

// =============================================================================
// ADMIN AUTH - Google Workspace OAuth
// For admins who provision households and users
// =============================================================================
export const googleAuthConfig = {
  clientId: import.meta.env.VITE_GOOGLE_CLIENT_ID || '',
  scopes: ['openid', 'email', 'profile'],
  redirectUri: `${window.location.origin}/admin/login`,
};

// Backwards compatibility - main app uses user config
export const msalConfig = userMsalConfig;
export const loginRequest = userLoginRequest;

// API endpoints
export const apiConfig = {
  baseUrl: import.meta.env.VITE_API_BASE_URL || '/api',
};
